import _sfc_main from "./FlowLoader.vue2.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const FlowLoader = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0fab9a31"]]);
export {
  FlowLoader as default
};
//# sourceMappingURL=FlowLoader.vue.js.map
